/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFDomainsEmailRecord
 */
export interface CRSFDomainsEmailRecord {
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFDomainsEmailRecord
     */
    domains: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof CRSFDomainsEmailRecord
     */
    total: number;
}

/**
 * Check if a given object implements the CRSFDomainsEmailRecord interface.
 */
export function instanceOfCRSFDomainsEmailRecord(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "domains" in value;
    isInstance = isInstance && "total" in value;

    return isInstance;
}

export function CRSFDomainsEmailRecordFromJSON(json: any): CRSFDomainsEmailRecord {
    return CRSFDomainsEmailRecordFromJSONTyped(json, false);
}

export function CRSFDomainsEmailRecordFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFDomainsEmailRecord {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'domains': json['domains'],
        'total': json['total'],
    };
}

export function CRSFDomainsEmailRecordToJSON(value?: CRSFDomainsEmailRecord | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'domains': value.domains,
        'total': value.total,
    };
}

